import { Loader2 } from "lucide-react";

export default function Loader({ className = "", size = "default" }) {
  const sizeClasses = {
    sm: "w-6 h-6",
    default: "w-10 h-10",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  };

  return (
    <div className={`min-h-screen flex items-center justify-center bg-background ${className}`}>
      <Loader2 className={`${sizeClasses[size]} animate-spin text-primary`} />
    </div>
  );
}
